export default {
  name: "attachment",
  props: ["title", "errorStep"],
  data() {
    return {
      file: undefined,
      fileRules: ""
    };
  },
  watch: {
    file(newFile) {
      if (newFile) {
        const maxSize = 4096;
        const fileSize = newFile.size / 1024;
        const isJpeg = newFile.type === "image/jpeg";
        const isPng = newFile.type === "image/png";
        if (!isPng && !isJpeg) {
          this.file = undefined;
          this.fileRules = this.$t(
            "ticketsPage.createTicket.attachment.fileFormatIsNotCorrect"
          );
        } else if (fileSize > maxSize) {
          this.fileRules = this.$t(
            "ticketsPage.createTicket.attachment.moreThanMaxSize"
          );
          this.file = undefined;
        } else {
          this.$emit("pushFileUp", newFile);
          this.fileRules = "";
        }
      } else {
        this.$emit("pushFileUp", null);
      }
    }
  }
};
